import axios from 'axios';
import localDB from '../utils/localDB';
import loadingService from './LoadingService';

const rootUrl = () => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_API_URL || '';
  }
  return ''; // Gebruik een lege string voor productie/acceptatie
}

const api = axios.create({
  baseURL: rootUrl()
});

// Request interceptor
api.interceptors.request.use(async (config) => {
  // Start loading spinner
  loadingService.startLoading();

  const token = await localDB.getItem('token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  // Stop loading on request error
  loadingService.stopLoading();
  return Promise.reject(error);
});

// Response interceptor
api.interceptors.response.use(
  (response) => {
    // Stop loading on successful response
    loadingService.stopLoading();
    return response;
  },
  (error) => {
    // Stop loading on response error
    loadingService.stopLoading();
    return Promise.reject(error);
  }
);

export default api;
